import { createContext, useContext, useEffect, useState } from "react";
import { api } from "@/lib/api";

const SiteCtx = createContext(null);

export function SiteProvider({ children }) {
  const [data, setData] = useState(null);
  const [error, setError] = useState(false);

  useEffect(() => {
    api.get("/public/bootstrap").then((r) => setData(r.data)).catch(() => setError(true));
  }, []);

  return <SiteCtx.Provider value={{ data, error }}>{children}</SiteCtx.Provider>;
}

export const useSite = () => {
  const { data } = useContext(SiteCtx);
  return { settings: data?.settings || {}, services: data?.services || [], sectors: data?.sectors || [], ready: !!data };
};

export const useSiteError = () => useContext(SiteCtx).error;
